import React from "react";

import { getStringFromBetween, pad2 } from "shared/lib/functions";

interface Props {
  duration: string;
}

const FormatDuration: React.FC<Props> = ({ duration }: Props) => (
  <span>
    <b>{getStringFromBetween.get(duration, "PT", "H")}</b> h{" "}
    <b>{pad2(getStringFromBetween.get(duration, "H", "M"))}</b> min
  </span>
);

export default FormatDuration;
